
import { useEffect, useRef } from "react";
import { useState } from "react";


function TableMenuCheckSelect(props) {
    const {displayCol} = props;
    const [isOpen, setIsOpen] = useState(false);
    const [allMenuList, setAllMenuList] = useState([]);


    useEffect(()=> {
        if(displayCol?.length){
            setAllMenuList(displayCol);
        }
    },[displayCol?.length, displayCol]);
  
    const toggleDropdown = () => setIsOpen(!isOpen);

   

    

    return (  
        <>
      <div className="relative inline-block text-left">
      <button
        onClick={toggleDropdown}
        className="bg-blue-500 text-white px-4 py-2 rounded-md shadow hover:bg-blue-600 focus:outline-none"
      >
        Column
      </button>

      {isOpen && (
      <div className="absolute mt-2 w-52 bg-white rounded-md shadow-lg z-10 p-3">
      {/* Scrollable section */}
      <div className="max-h-48 overflow-y-auto space-y-1 pr-1">
        {allMenuList.map((menu, i) => (
          <label
            key={i}
            className="flex items-center justify-between py-1 px-2 hover:bg-gray-100 rounded"
          >
            <span>{menu?.Column_Name}</span>
            <input
              type="checkbox"
              checked={menu?.Display_Id === 1 ? true: false}
              onChange={ ()=> props?.handleCheckboxChange(menu, menu?.Display_Id === 1 ? 2: 1)}
              className="form-checkbox h-4 w-4"
            />
          </label>
        ))}
      </div>
    
      {/* Footer buttons */}
      <div className="flex justify-between pt-2 mt-2 border-t border-gray-200">
        <button
          onClick={()=> props?.saveCurrentTableHeader()}
          className="text-sm bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
        >
          Save
        </button>
        <button
          onClick={()=> setIsOpen(false)}
          className="text-sm bg-gray-200 text-gray-800 px-3 py-1 rounded hover:bg-gray-300"
        >
          Cancel
        </button>
      </div>
    </div>
    
      )}
    </div>
  

        </>
    );
}

export default TableMenuCheckSelect;